import { SupportedFeaturesTargets, TargetOption } from 'data/supportedFeatures/supportedFeatures.types';
import { FormTemplate } from 'data/template/template.types';

const buildTargetFiledsTemplate = (option: TargetOption) => {
  const validators = [];

  if (option.pattern != null) {
    validators.push({
      type: 'regexp',
      regexp: option.pattern,
      errorMessage: `Can include letters, digits and the following special characters: ${option.pattern}. Please re-enter.`,
    })
  }

  if (option.maxLength !== null && (option?.maxLength as number) > 0) {
    validators.push({
      type: 'length',
      length: Number(option.maxLength),
      errorMessage: `Can exced the maximun ${option.maxLength} characters. Please re-enter.`,
    },)
  }

  return {
    type: option.type,
    label: option.title,
    key: option.key,
    initial: '',
    validation: {
      validators,
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export const getSupportedTargetWithTargetOptions = (
  supportedFeaturesTargets: SupportedFeaturesTargets,
  shouldDisable: boolean
): FormTemplate[] => {

  return Object.keys(supportedFeaturesTargets)
    .filter((key: string) => supportedFeaturesTargets[key].targetOptions)
    .map((key: string) => ({ target: key, targetOptions: supportedFeaturesTargets[key].targetOptions }))
    .map((data: { target: string, targetOptions?: TargetOption[] }) => {

      const { target, targetOptions } = data;

      const rows = (targetOptions || []).map((option) => [option.key]);

      const fields = (targetOptions || [])
        .map(buildTargetFiledsTemplate)
        .reduce((template, field) => ({ ...template, [field.key]: { ...field, disabled: shouldDisable } }), {});

      return {
        version: '1.0.0',
        name: target,
        key: target,
        main: {
          metadata: {
            layout: {
              rows,
            },
          },
          fields: {
            ...fields,
            id: {
              type: 'text',
              hide: 'true',
              initial: '',
            },
          },
        },
      }
    });
}
